module.exports = __webpack_public_path__ + "static/8-31b1ee204bd1f28847f9a46aa36ae303.jpg";